<section class="error">
  <div class="error__inner">
      <h1>404</h1>
      <h2>{{'error.label.404' | translate}}</h2>
      <p>{{'error.label.404.desc' | translate}}</p>

      <button class="btn btn-primary" (click)="goBack()"> {{ 'generic.label.go.back' | translate}} </button>

  </div>
</section>
